var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('YContainer',[_c('z-breadcrumb',{attrs:{"items":[
      { text: 'Página inicial', url: 'https://querobolsa.com.br/' },
      { text: 'Programas do Governo', url: 'https://querobolsa.com.br/programas-do-governo' },
      { text: _vm.pageName } ]}}),_vm._v(" "),_c('FinancialAidArticle',{attrs:{"page":_vm.page}}),_vm._v(" "),_c('CampaignBanner',{attrs:{"campaign-data":_vm.campaignData,"is-loading":_vm.campaignLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }